import React, {useEffect} from 'react';
import {useAppSelector} from "../../creator-presets/DAL/store";
import {PresetPluginDM} from "../interfaces";
import Gallery from "../../../galleries/gallery/gallery";
import GridProduct from "../../../products/product/grid-product";
import {useWindowSize} from "../../../../domain/common";
import { getListItemByPresetPlugin } from '../services/logic-helper';
import {initEqualHeight} from "../../../list-page/services/list-page-provider";

const PresetPlugins = () => {
    const PresetPageData = useAppSelector((store) => store.PresetPageData);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const size = useWindowSize();

    useEffect(() => {

        (async () => {
            setTimeout(function() { //Start the timer
                let $container = document.getElementById('gallery-container') as HTMLDivElement;
                initEqualHeight($container,size.width !== undefined ? size.width : 0,"grid",PresetPageData.presetsPlugins.length,PresetPageData.presetsPlugins.length,PresetPageData.presetsPlugins.length);
            }, 100);
        })();

    },[size.width,PresetPageData.presetsPlugins.length]);
    return (
        <div className="w-full mt-10">
            <div  className="w-full font-bold text-2xl">Featured plugins in this chain</div>
            {size && <div className="w-full mt-4" id="gallery-container">
                <Gallery
                    allowVerticalScrolling={ true }
                    isArrowsOverflow={ true }
                    arrowsHeightWidthRatio={1}

                    classes={ "w-full" }
                    desktopItemsPerSlide={ 4 }
                    tableItemsPerSlide={ 3 }
                    mobileItemsPerSlide={ 1.5 }
                    codeName="fmo"
                    items={ PresetPageData.presetsPlugins }
                    loop={ false }
                    duration={ 800 }
                    renderItem={(item: PresetPluginDM, slideItemHeight: number) => {
                        const listItem = getListItemByPresetPlugin(item, imgCdnDomain);

                        return (
                            <div style={{
                                height: 'auto'
                            }}>
                                <GridProduct
                                    product={ listItem }
                                    removeImgLink={ false }
                                    removeTitleLink={ false }
                                    isButtonAndNoteHidden = { !listItem.skuEnabled }
                                    classes={ 'h-full' }
                                    listName={listItem.title}
                                    isPriceClockHidden={ true }
                                />
                            </div>

                        )
                    }}
                />
            </div>}

        </div>

    )
};

export default PresetPlugins;